document.querySelectorAll('[data-service-directory]').forEach(directory=>{
  const controls=directory.querySelector('[data-service-controls]');
  const search=directory.querySelector('[data-service-search]');
  const certified=directory.querySelector('[data-service-rcp]');
  const count=directory.querySelector('[data-service-count]');
  const empty=directory.querySelector('[data-service-empty]');
  const cards=[...directory.querySelectorAll('[data-service-card]')];
  if(!controls||!search||!certified||!count||!empty)return;
  const normalize=value=>value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase('sv').replace(/\s+/g,' ').replace(/(\d{3})\s+(\d{2})(?=\D|$)/g,'$1$2').trim();
  const index=cards.map(card=>({card,text:normalize(card.dataset.search||'')}));
  function filter(){
    const terms=normalize(search.value).split(' ').filter(Boolean);let visible=0;
    index.forEach(({card,text})=>{card.hidden=!(terms.every(term=>text.includes(term))&&(!certified.checked||card.dataset.rcp==='true'));if(!card.hidden)visible++;});
    count.textContent=(count.dataset.countTemplate||'__COUNT__ / __TOTAL__').replace('__COUNT__',String(visible)).replace('__TOTAL__',String(cards.length));
    empty.hidden=visible!==0;
  }
  search.addEventListener('input',filter);certified.addEventListener('change',filter);
  directory.querySelectorAll('[data-service-map-area]').forEach(link=>link.addEventListener('click',event=>{
    event.preventDefault();search.value=link.dataset.serviceMapArea;certified.checked=false;filter();
    const target=cards.find(card=>!card.hidden);if(target){target.focus({preventScroll:true});target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});}
  }));
  directory.querySelectorAll('[data-service-reset]').forEach(button=>button.addEventListener('click',()=>{search.value='';certified.checked=false;filter();search.focus();}));
  controls.hidden=false;filter();
});
